import { withI18n } from './i18n';
export const registerBundle = (bundleName, bundleDescriptor) => {
    window.repluggableArtifacts = window.repluggableArtifacts || {};
    window.featuresMap = window.featuresMap || {};
    if (bundleDescriptor.featuresMap) {
        Object.entries(bundleDescriptor.featuresMap).forEach(([feature, entryPoints]) => {
            window.featuresMap[feature] = window.featuresMap[feature] || new Set();
            entryPoints.forEach(ep => window.featuresMap[feature].add(ep));
        });
    }
    if ('enJson' in bundleDescriptor) {
        const initBundle = (options) => withI18n(options, bundleDescriptor.packages, bundleDescriptor.enJson, bundleDescriptor.langResolver);
        window.repluggableArtifacts[bundleName] = initBundle;
    }
    else {
        window.repluggableArtifacts[bundleName] = bundleDescriptor.packages;
    }
};
//# sourceMappingURL=bundleInitializer.js.map